import alfanar from "@/assets/customers/alfanar.png.asset.json";
import aslcab from "@/assets/customers/aslcab.png.asset.json";
import bewa from "@/assets/customers/bewa.png.asset.json";
import dayco from "@/assets/customers/dayco.png.asset.json";
import ducab from "@/assets/customers/ducab.png.asset.json";
import egyplast from "@/assets/customers/egyplast.png.asset.json";
import elsewedy from "@/assets/customers/elsewedy.png.asset.json";
import ep from "@/assets/customers/ep.png.asset.json";
import fico from "@/assets/customers/fico.png.asset.json";
import gulfCables from "@/assets/customers/gulf-cables.png.asset.json";
import metsol from "@/assets/customers/metsol.png.asset.json";
import muviq from "@/assets/customers/muviq.png.asset.json";
import procab from "@/assets/customers/procab.png.asset.json";
import sterlite from "@/assets/customers/sterlite.png.asset.json";
import ubm from "@/assets/customers/ubm.png.asset.json";
import uzauto from "@/assets/customers/uzauto.png.asset.json";

export type CustomerLogo = { key: string; name: string; src: string; url?: string };

/** Bundled fallback: the 16 customer logos shown on the homepage (customers, not partners). */
export const CUSTOMER_LOGOS: CustomerLogo[] = [
  { key: "alfanar", name: "alfanar", src: alfanar.url },
  { key: "muviq", name: "MUVIQ", src: muviq.url },
  { key: "egyplast", name: "Egyplast", src: egyplast.url },
  { key: "ducab", name: "Ducab", src: ducab.url },
  { key: "fico", name: "FICO", src: fico.url },
  { key: "sterlite", name: "Sterlite", src: sterlite.url },
  { key: "procab", name: "ProCab", src: procab.url },
  { key: "elsewedy", name: "Elsewedy Electric", src: elsewedy.url },
  { key: "uzauto", name: "UzAuto Motors", src: uzauto.url },
  { key: "ep", name: "Emirates Polystyrene Industries", src: ep.url },
  { key: "bewa", name: "BEWA", src: bewa.url },
  { key: "metsol", name: "Metsol", src: metsol.url },
  { key: "gulf-cables", name: "Gulf Cables & Electrical Industries Group", src: gulfCables.url },
  { key: "aslcab", name: "AslCab", src: aslcab.url },
  { key: "dayco", name: "Dayco", src: dayco.url },
  { key: "ubm", name: "Universal Business Machines", src: ubm.url },
];
